
import {
    CHANGE_PHONE_POPUP_CK,
    CHANGE_PHONE_POPUP_EX,
    CHANGE_PHONE_POPUP_JUMP_BT,
    CHANGE_PHONE_POPUP_LOADING_TIME_SW,
    CHANGE_PHONE_POPUP_PHONE_BT,
    CHANGE_PHONE_POPUP_SW,
    CHANGE_PHONE_POPUP_TIME_SW,
    CHANGE_PHONE_POPUP_TYP,
    DV_CODE_BT,
    DV_CODE_CK,
    DV_CODE_FULL_SW,
    DV_CODE_IMAGE_LOADING_TIME_SW,
    DV_CODE_IMAGE_SW,
    DV_CODE_JUMP_BT,
    DV_CODE_LOADING_TIME_SW,
    DV_CODE_SW,
    DV_CODE_TIME_EX,
    DV_CODE_TIME_SW,
    DV_CODE_TYP,
    VERIFICATION_CODE_AGAIN_BT,
    VERIFICATION_CODE_BT,
    VERIFICATION_CODE_CK,
    VERIFICATION_CODE_EX,
    VERIFICATION_CODE_LOADING_TIME_SW,
    VERIFICATION_CODE_PHONE_BT,
    VERIFICATION_CODE_SW,
    VERIFICATION_CODE_TIME_SW,
    VERIFICATION_CODE_TYP,
    VERIFICATION_CODE_TYPING_TIME_SW,
    VERIFICATION_CODE_WAITING_TIME_SW
} from '../constants/loginTrack';
import {
    EXPOSE_SUCCESS_SW,
    LOGIN_STATUS_BT,
    PHONE_VERIFY_SW,
    REG_LOGIN_FAIL_SW,
    REG_LOGIN_SUCCESS_SW
} from '../enums/track';

import type { LoginTrackBids } from '@/components/fifaLogin/types';

export const creditCardLoginTrackBids: LoginTrackBids = {
    passportVerify: PHONE_VERIFY_SW,
    loginSuccess: REG_LOGIN_SUCCESS_SW,
    loginFail: REG_LOGIN_FAIL_SW,
    registerExpose: EXPOSE_SUCCESS_SW,

    dvCodeLoadingTimeSw: DV_CODE_LOADING_TIME_SW,
    dvCodeImageLoadingTimeSw: DV_CODE_IMAGE_LOADING_TIME_SW,
    dvCodeSw: DV_CODE_SW,
    dvCodeImageSw: DV_CODE_IMAGE_SW,
    dvCodeFullSw: DV_CODE_FULL_SW,
    dvCodeTimeSw: DV_CODE_TIME_SW,
    dvCodeTimeEx: DV_CODE_TIME_EX,
    dvCodeCk: DV_CODE_CK,
    dvCodeTyp: DV_CODE_TYP,
    dvCodeBt: DV_CODE_BT,
    dvCodeJumpBt: DV_CODE_JUMP_BT,

    verificationCodeLoadingTimeSw: VERIFICATION_CODE_LOADING_TIME_SW,
    verificationCodeSw: VERIFICATION_CODE_SW,
    verificationCodeTimeSw: VERIFICATION_CODE_TIME_SW,
    verificationCodeEx: VERIFICATION_CODE_EX,
    verificationCodeCk: VERIFICATION_CODE_CK,
    verificationCodeTyp: VERIFICATION_CODE_TYP,
    verificationCodePhoneBt: VERIFICATION_CODE_PHONE_BT,
    verificationCodeBt: VERIFICATION_CODE_BT,
    verificationCodeWaitingTimeSw: VERIFICATION_CODE_WAITING_TIME_SW,
    verificationCodeTypingTimeSw: VERIFICATION_CODE_TYPING_TIME_SW,
    verificationCodeAgainBt: VERIFICATION_CODE_AGAIN_BT,

    changePhonePopupLoadingTimeSw: CHANGE_PHONE_POPUP_LOADING_TIME_SW,
    changePhonePopupSw: CHANGE_PHONE_POPUP_SW,
    changePhonePopupTimeSw: CHANGE_PHONE_POPUP_TIME_SW,
    changePhonePopupEx: CHANGE_PHONE_POPUP_EX,
    changePhonePopupCk: CHANGE_PHONE_POPUP_CK,
    changePhonePopupTyp: CHANGE_PHONE_POPUP_TYP,
    changePhonePopupPhoneBt: CHANGE_PHONE_POPUP_PHONE_BT,
    changePhonePopupJumpBt: CHANGE_PHONE_POPUP_JUMP_BT
};
